export const TRANBILOG_URL = `${process.env.TRANBILOG_URL}`;

export const RECIPIENT_HOST = `${process.env.ANKETA_MAIN_HOST}`;

export const RECIPIENT_URL = `${RECIPIENT_HOST}/alfaform-common-land/?`;
